import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Panel } from '@core/models/panel';
import { OrdersService } from '@core/services/orders.service';
import { PanelsService } from '@core/services/panels.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'planner-example',
  templateUrl: './planner-example.component.html',
  //styleUrl: './planner-example.component.scss',
})
export class PlannerExampleComponent implements OnInit, OnDestroy {
  private panels$: Subscription = new Subscription();
  panels: Panel = {};
  selectedDate: Date = new Date();

  @Output() panelsChange = new EventEmitter<Panel>();

  constructor(
    private _panelsService: PanelsService,
    private _ordersService: OrdersService,
  ) { }
  ngOnInit() {
    // subscribe to object registered in related service
    this.panels$ = this._panelsService.panels$.subscribe((panels: Panel) => {
      this.panels = panels;
      this.panelsChange.emit(panels);
  });
  }
  onOpenClick() {
    this._ordersService.openNewOrderPanel();
  }

  onCloseClick() {
    this._panelsService.closeOrderPanel();
  }

  ngOnDestroy() {
    // unsubscribe to object on component destruction -> unhandled subscriptions could result in outdated data
    this.panels$.unsubscribe();
  }

}
